<div>
            <table style="font-size: medium">
                <tr>
                    <td style="vertical-align:top;">
                        @if(this.Team.team.SmallIconFileName){
                            <img [src]="('/assets/img/' + this.Team.team.SmallIconFileName).replace('//', '/').toLowerCase()" style="height: 64px;" class="ui-li-icon" />

                        }
                    </td>
                    <td>
                        <b>{{this.Team.team.Name}}</b><br />
                        <label style="font-family:Arial; font-size: small;">{{this.Team.team.Division}}</label>
                    </td>
                </tr>
               
                <tr>

                    <td>
                       
                       

                    </td>
                    <td></td>
                </tr>

            </table>

</div>
